module.exports = __webpack_public_path__ + "static/maarten-van-den-heuvel-73123-unsplash-0c1731da7f5a8c9cd95567b0ed27a817.jpg";